import { TranslationsProvider } from '../contexts'

export default translations => ({
  wrappingComponent: TranslationsProvider,
  wrappingComponentProps: { translations },
})
